module.exports = __webpack_public_path__ + "c699ce4fb65d1fbc0e74e7e080a65fa4.svg";